// Importing countries
import { COUNTRIES_NL } from './countries';

export const LANG_NL_CODE = 'nl-NL';
export const LANG_NL_NAME = 'NL';
export const LANG_NL_COMPLETE_NAME = 'Nederlands';
// ==== SUPPORTED LANGUAGES ====
// =============================
const LANG_NL = {
  'en-US': 'English',
  'es-ES': 'Español',
  'da-DA': 'Dansk',
  'fr-FR': 'Français',
  'fr-CA': 'Français (Canada)',
  'de-DE': 'Deutsch',
  'nl-NL': 'Nederlands',
  'ENGLISH': 'English',
  'SPANISH': 'Español',
  'DANISH': 'Dansk',
  'FRENCH': 'Français',
  'CANADIAN FRENCH': 'Français (Canada)',
  'GERMAN': 'Deutsch',
  'DUTCH': 'Nederlands',
  'MORE_INFO': 'Meer informatie',
  // =========== LOGIN ===========
  // =============================
  'HOME': {
    'TITLE': 'Group Knowledge is Power',
    'TEXT': 'Concept Systems Incorporated brings organizations working on any collaborative initiative superior processes for capturing group wisdom from different points of view.'
  },
  'AUTO_LOGOUT': {
    'WARNING': {
      'TITLE': 'Bent u er nog?',
      'BUTTON': 'Ga verder met werken',
      'MESSAGE': 'Voor veiligheidsredenen, zullen we u uitloggen als I nog inactief bent na',
      'SECONDS': 'seconden',
    }
  },
  'LOGIN': {
    'USERNAME': 'Gebruikersnaam',
    'USERNAME_OR_EMAIL': 'GEBRUIKERSNAAM OF E-MAIL',
    'OR': 'of',
    'ACTIVATE_ACCOUNT': 'Activeer uw account',
    'ACTIVATE_ACCOUNT_TEXT': 'Maak een account aan en draag bij aan belangrijke onderzoeksprojecten!',
    'ASSIGNED_USERNAME': 'TOEGEWEZEN GEBRUIKERSNAAM',
    'YOUR_USERNAME': 'UW GEBRUIKERSNAAM',
    'ANONYMOUS_ACCOUNT': 'Anoniem account',
    'DIFFERENT_EMAIL': 'Ik wil een ander e-mailadres gebruiken',
    'PASSWORD': 'WACHTWOORD',
    'FORGOT_PASSWORD': 'Wachtwoord vergeten?',
    'LOCKED_ACCOUNT': '*Uw account is geblokkeerd. Neem contact op met het projectteam',
    'INVALID_USER': 'Ongeldige gebruikersnaam of wachtwoord. Probeer het opnieuw of neem contact op met het projectteam.',
    'WRONG_PASSWORD_1': 'Verkeerd wachtwoord! U heeft nog 1 poging',
    'WRONG_PASSWORD': 'Verkeerd wachtwoord! U heeft nog',
    'MORE_TRIES': 'pogingen!',
    'RESET_PASSWORD': 'Wachtwoord opnieuw instellen',
    'DONE': 'GEREED',
    'INVITE_PROMPT': 'Je bent uitgenodigd om deel te nemen aan een nieuw project',
    'INVITE_PROCEED': 'ga door naar project',
    'HAVE_ACCOUNT': 'Heeft u al een account?',
    'ASSIGNED_ACCOUNT': 'Als u een TOEGEWEZEN gebruikersnaam en wachtwoord hebt,',
    'ASSIGNED_LINK': 'KLIK HIER',
    'LOGIN_HERE': 'Hier inloggen',
    'RESET_EXPIRE': 'De link om uw wachtwoord opnieuw in te stellen is verlopen. Vraag hieronder een nieuwe link aan om uw wachtwoord opnieuw in te stellen',
    'RESEND': 'OPNIEUW VERZENDEN',
    'PWD_CONFIRMATION': 'Bevestiging van nieuwe wachtwoord',
    'PDW_CHANGE_SUCCESSFULLY': 'Uw wachtwoord is gewijzigd',
    'CONTINUE': 'DOORGAAN',
    'CREATE_PASSWORD': 'Wachtwoord aanmaken',
    'CREATE_ACCOUNT': 'Account aanmaken',
    'CP_SUBTITLE': 'Stel een wachtwoord in voor uw anonieme account',
    'CP_SUBTITLE_USERNAME': 'Stel een wachtwoord in voor uw toegewezen gebruikersnaam',
    'CP_SUBTITLE_EMAIL': 'Stel een wachtwoord in voor uw e-mail',
    'ANONYMOUS_SUGGESTION_TEXT': 'Wij raden u sterk aan om dit op te schrijven.',
    'WHY': 'Waarom?',
    'CONFIRM_PASSWORD': 'BEVESTIG WACHTWOORD',
    'LOG_IN': 'Log in',
    'FINISH_SU_ACCOUNT': 'Voltooi het instellen van uw account',
    'EMAIL': 'E-MAIL',
    'CHECK_INBOX': 'Check uw e-mail inbox',
    'EMAIL_TEXT_NOTIFICATION': 'We hebben een e-mail gestuurd naar',
    'EMAIL_TEXT_NOTIFICATION_2': 'met een link om uw account te activeren.',
    'CLICK_LINK': 'Klik op de link en u bent klaar om verder te gaan!',
    'BACK_LOGIN': 'Terug naar Inloggen',
    'SEND_EMAIL_TEXT_NOTIFICATION': 'We sturen u een e-mail met instructies voor het opnieuw instellen van uw wachtwoord naar het volgende adres:',
    'FP_EMAIL_TEXT_NOTIFICATION': 'Er is een e-mail onderweg. U krijgt instructies over hoe u uw wachtwoord opnieuw kunt instellen. Zorg dat u ook uw map met ongewenste e-mail (spam) controleert, de e-mail kan daar terecht gekomen zijn.',
    'DIDNT_GET_EMAIL': 'Heeft u de e-mail niet gekregen?',
    'RESEND_LINK': 'Stuur mij de link opnieuw',
    'RESET_PASSWORD_SUCCESS': 'Neem contact op met uw projectteam om uw wachtwoord opnieuw in te stellen.',
    'NO_ACTIVITIES': {
      'OOPS': 'Oeps!',
      'TEXT_MAIN': 'Het lijkt erop dat dit project het benodigde aantal bijdragers heeft bereikt. Voor vragen kunt u contact opnemen met de projectbeheerder. <a href="mailto:support@conceptsystems.com">Neem contact op met een beheerder</a> als u vragen heeft',
      'TEXT_NO_ACTIVITIES': 'Er zijn momenteel geen activiteiten voor deze projectlink geopend. Voor vragen kunt u contact opnemen met de projectbeheerder!',
    },
    'INFO_REGISTER_IDENTIFIER': 'Projectbeheerders kunnen u een e-mail sturen via het systeem op basis van uw deelnamestatus, maar kunnen uw e-mailadres niet zien om verbinding te maken met uw ID.',
    'BROKEN_LINK': {
      'INFORMATION': 'Informatie:',
      'PROJECT_CONTACT': 'Project contactpersoon:',
      'CAUSE': 'De gebruikte link werkt niet. Controleer de originele link en probeer het opnieuw.',
      'TEXT': 'Voor vragen kunt u contact opnemen met de projectbeheerder!',
    },
    'CERATE_ACCOUNT': 'ACCOUNT AANMAKEN',
    'CREATE_ACCOUNT_IDENTIFIER': {
      'TITLE_CREATE': 'Account aanmaken',
      'TITLE_START': 'en begin met het bijdragen van uw ideeën',
      'STUDENT_ID': 'STUDENT-ID',
      'EMAIL': 'E-MAIL',
      'EMAIL_INFO': 'Uw e-mailadres is niet zichtbaar voor het projectteam',
      'CREATE_A_PASSWORD': 'MAAK EEN WACHTWOORD AAN',
      'STRONG': 'Sterk',
      'WEAK': 'Zwak',
      'INVALID_USERNAME': 'Ongeldige gebruikersnaam, probeer het opnieuw',
      'INCOMPLETE_USERNAME': 'U moet een gebruikersnaam invoeren',
      'USERNAME': 'Gebruikersnaam',
      'CHARACTERS_MINIMUM': 'Uw wachtwoord moet minimaal uit 6 tekens bestaan',
      'SAME_USERNAME': 'Uw wachtwoord mag niet hetzelfde zijn als uw gebruikersnaam',
      'MISSING_DIGIT': 'Je wachtwoord moet minimaal één cijfer bevatten',
      'MISSING_UPPERCASE': 'Je wachtwoord moet minimaal één hoofdletter bevatten',
      'MISSING_LOWERCASE': 'Je wachtwoord moet minimaal één kleine letter bevatten',
      'MISSING_SYMBOL': 'Je wachtwoord moet minimaal één niet-alfabetisch teken bevatten',
      'PASSWORD_MAX': 'U moet een wachtwoord invoeren',
      'PASSWORD_PLACEHOLDER': 'Voer uw wachtwoord in',
      'SECURE_PASSWORD': 'Een veilig wachtwoord moet ten minste het volgende bevatten:',
      'BASE_DIGIT': 'één nummer (0 t/m 9)',
      'UPPERCASE_CHARACTER': 'één hoofdletter (a tot en met z)',
      'LOWERCASE_CHARACTER': 'één kleine letter (a tot en met z',
      'ALPHABETIC_CHARACTER': 'één niet-alfabetisch teken (bijvoorbeeld !, $, %, #)',
      'MUST_PASSWORD_AGAIN': 'U moet uw wachtwoord opnieuw invoeren',
      'PASSWORD_NOT_MATCH': 'Wachtwoorden komen niet overeen',
      'PASSWORD_AGAIN': 'Voer nogmaals uw wachtwoord in',
    }
  },
  // ========= AUTOSAVE ==========
  // =============================
  'SAVING_STATUS': {
    'SAVED': 'Alle wijzigingen zijn opgeslagen',
    'SAVING': 'Opslaan',
  },
  // ==== MY PROJECTS ===========
  // ============================
  'MY_PROJECTS': {
    'TITLE': 'Mijn projecten',
    'TEXT': 'Klik op een project om de toegewezen activiteiten te voltooien.',
    'NO_PROJECT': {
      'TITLE': 'Oeps!',
      'TEXT': 'U bent momenteel niet toegewezen aan openstaande projectactiviteiten.',
    }
  },
  // ==== SYSTEM ERROR ===========
  // ============================
  'SYSTEM_ERROR': {
    'TITLE': 'Onverwachte systeemfout',
    'MESSAGE': {
      'TITLE': 'Oeps!',
      'TEXT': 'Er is een onverwachte systeemfout opgetreden. Probeer het over een paar minuten opnieuw. Als de fout aanhoudt, neem dan contact op met',
      'EMAIL': 'support@conceptsystems.com',
    }
  },
  // ==== MY ACCOUNT ===========
  // ============================
  'MY_ACCOUNT': {
    'TITLE': 'Mijn account',
    'INFORMATION': 'Uw accountgegevens',
    'USERNAME': 'Gebruikersnaam',
    'EMAIL': 'E-mail',
    'PERSONAL_DETAILS': 'Persoonlijke gegevens',
    'FIRST_NAME': 'VOORNAAM',
    'EDIT': 'Bewerken',
    'SAVE': 'Opslaan',
    'LAST_NAME': 'ACHTERNAAM',
    'CHANGE_PASSWORD': 'Verander wachtwoord',
    'DONT_SEND_EMAIL': 'Stuur mij geen GroupWisdom-e-mails meer',
    'CURRENT_PASSWORD': 'Huidig ​​wachtwoord',
    'NEW_PASSWORD': 'Nieuw wachtwoord',
    'CONFIRM_PASSWORD': 'Bevestig wachtwoord',
    'CHANGED': 'Gewijzigd:',
    'ANONYMOUS_ACCOUNT': 'Anoniem account',
    'TERMS': {
      'SHOW': 'Laat zien',
      'LABEL': 'GroepWisdom Term',
    },
    'PRIVACY': {
      'SHOW': 'Laat zien',
      'LABEL': 'GroepWisdom Privacy',
    },
    'ANONYMOUS_TOOLTIP': 'Met een anoniem account is uw identiteit niet bekend bij het projectteam',
  },
  // ==== HEADER  =================
  // =============================
  'HEADER': {
    'MY_PROJECTS': 'Projecten',
    'MY_ACCOUNT': 'Account',
    'NOTIFICATIONS': 'Meldingen',
    'HELP_AND_SUPPORT': 'Hulp en Ondersteuning',
    'SIGN_OUT': 'Afmelden',
    'CHOSE_LANGUAGE': 'Selecteer taal',
  },
  // ==== FOOTER =================
  // =============================
  'FOOTER': {
    'ITEMS': {
      'PRIVACY': 'Privacy',
      'TERMS': 'Voorwaarden',
      'HELP': 'Hulp & Ondersteuning',
    },
    'COPYRIGHT': 'Copyright © 2000-2023. Alle rechten voorbehouden. Mogelijk gemaakt door',
    'COPYRIGHT_STRING': 'Concept Systems, Inc',
  },
  // ==== NOTIFICATIONS =================
  // =============================
  'NOTIFICATIONS': {
    'TITLE' : 'MELDINGEN',
    'TITLE_NO' : 'GEEN NIEUWE MELDINGEN',
    'TITLE_SINGLE' : 'EEN NIEUWE MELDING',
    'TITLE_MULTIPLE' : 'NIEUWE MELDINGEN',
    'ALL': 'Alle meldingen',
    'PAGER': {
      'SHOWING': 'TONEN',
      'TO' : 'AAN',
    },
    'NOTIFICATION': 'Melding',
    'FROM': 'Van:',
  },
  // ==== INFORMED CONSENT MODAL ===========
  // =======================================
  'INFORMED_CONSENT_MODAL': {
    'TITLE': 'Toestemming om deel te nemen',
    'DOWNLOAD': 'Toestemmingsformulier downloaden',
    'UPLOAD': 'Upload ondertekend toestemmingsformulier',
    'TOOLTIP': 'Onderteken het toestemmingsformulier en upload het om te blijven deelnemen aan het project.',
    'ACCEPT': 'ACCEPTEREN',
    'DECLINE': 'AFWIJZEN',
    'FILE_ERROR': {
      'TYPE': 'Toestemming om deel te nemen kan alleen als .pdf, .doc, .docx worden geüpload.',
      'SIZE': 'Bestandslimiet is 10 MB, probeer het opnieuw.',
    },
    'NO_DATA': 'Gegevens over geïnformeerde toestemming zijn niet verstrekt',
  },
  // ==== THANK YOU MODAL ===========
  // =======================================
  'THANK_YOU_MODAL': {
    'BUTTON_LINK': 'VOLGENDE',
  },
  // ==== DECLINE INFORMED CONSENT MODAL ========
  // ============================================
  'DECLINE_ICM': {
    'TITLE': 'U weigerde',
    'TEXT': 'U kunt niet doorgaan met de projectactiviteiten zonder de toestemming voor deelname te accepteren.',
    'TEXT_1': 'Neem bij vragen contact op met het projectteam.',
    'CONTINUE': 'DOORGAAN',
    'SING_OUT': 'Afmelden',
  },
  // ====== PROJECT ===========================
  // ==========================================
  'PROJECT': {
    'SHOW_PI': 'Bekijk projectinfo',
    'VIEW_IC': 'Bekijk toestemming om deel te nemen',
    'AVAILABLE_ACTIVITIES': 'UW BESCHIKBARE ACTIVITEITEN',
    'AVAILABLE_ACTIVITIES_TOOLTIP': 'Selecteer één van de lege, gestarte of voltooide activiteitvakken om items in die activiteit in te voeren en te bewerken. Als een activiteit nog niet eerder is ingevoerd, wordt deze weergegeven als open/leeg. Wanneer een activiteit is ingevoerd, wordt deze weergegeven als gestart totdat deze is voltooid. De activiteit zal als voltooid worden weergegeven wanneer alle items in de activiteit zijn voltooid of als u voltooid heeft geselecteerd.',
    'PROJECT_INFO_MODAL': {
      'TITLE': 'Contactgegevens van het project',
      'PHONE': 'Telefoonnummer:',
      'EMAIL': 'E-mailadres:',
      'NO_DATA': 'Dit project heeft geen contactgegevens',
    },
    'PREVIEW': {
      'EXIT_TITLE': 'U bekijkt een voorbeeld als deelnemer.',
      'EXIT_BUTTON': 'Voorbeeld afsluiten',
    },
    'NO_ACTIVITIES': {
      'OOPS': 'Oeps!',
      'TEXT_MAIN': 'Het lijkt erop dat dit project het benodigde aantal bijdragers heeft bereikt.',
      'TEXT': 'Er zijn geen activiteiten aan u toegewezen',
    },
    'BRAINSTORMING': 'Brainstormen',
    'SORTING': 'Sorteren',
    'RATING': 'Beoordelen',
    'PQ': 'Vragen over de participant',
    'CLOSES': 'Sluiten',
  },
  // ==== BRAINSTORMING ========
  // ============================================
  'BRAINSTORMING': {
    'TITLE': 'Brainstormen',
    'INFO': 'Informatie',
    'INFORMATION': 'Denk goed na over uw ideeën. U kunt ideeën vanuit verschillende invalshoeken en ervaringen met betrekking tot de focusvraag toevoegen.',
    'ADD_IDEAS': 'Ideeën toevoegen',
    'COLLECTED_STATEMENTS': 'Verzamelde uitspraken:',
    'COLLECTED_STATEMENTS_TOOLTIP': 'Dit zijn uitspraken verzameld van alle deelnemers. De lijst wordt vernieuwd wanneer u een uitspraak toevoegd of op "Lijst verversen" drukt.',
    'REFRESH': 'Lijst verversen',
    'FINISH': 'Voltooi',
    'STATEMENTS': {
      'ADD': 'Uitspraak toevoegen',
      'NEW_STATEMENT_PLACEHOLDER': 'Typ hier om een ​​idee toe te voegen',
    },
    'ACTIONS': {
      'SEARCH': {
        'PLACEHOLDER': 'Zoeken',
      }
    },
    'FOCUS_PROMPT': 'FOCUSVRAAG',
    'MOBILE_STATEMENTS': 'uitspraken',
    'COLLECTED': 'verzameld',
    'FOCUS_PROMPT_TOOLTIP': 'Deze zin is de focusvraag van het project. De focusvraag kan om u te helpen ideeën te genereren over de inhoud van het project. De uitspraken zullen gebruikt worden voor andere activiteiten in dit onderzoek.',
    'HIDE_PROMPT': 'Verberg focusvraag',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Toon introductie',
      'SHOW_TOUR_AGAIN': 'Tour opnieuw tonen',
      'LEAVE': 'Brainstormen verlaten',
      'FINISH': 'Brainstormen voltooien',
    },
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'START',
      },
      'LIMIT': {
        'TITLE': 'Brainstormlimiet',
        'DESCRIPTION': 'De limiet van het aantal uitspraken voor dit project is bereikt. U kunt geen uitspraken meer toevoegen.',
        'BUTTON': 'SLUITEN',
      }
    },
    'PROJECT_HOME': 'Startpagina project',
    'RETURN': 'Terugkeren naar',
    'THANK_YOU': {
      'TITLE': 'Bedankt',
      'BUTTON': 'TERUG NAAR STARTPAGINA PROJECT',
      'BUTTON_LINK': 'VOLGENDE',
    },
    'TEXTAREA': {
      'PLACEHOLDER': 'Typ hier om een ​​idee toe te voegen',
    },
    'CHARACTERS_LEFT': 'tekens over',
  },
  // === PARTICIPANT QUESTIONS ===
  // =============================
  'PARTICIPANT_QUESTIONS': {
    'TITLE': 'Vragen over de participant',
    'PAGE': 'Pagina',
    'OF': 'van',
    'FINISH': 'Voltooi',
    'BACK': 'Terug',
    'NEXT': 'Volgende',
    'DECIMALS_ALLOWED': 'Maximaal %0 decimalen toegestaan.',
    'RANGE': 'Min: %0 Max: %1',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Toon introductie',
      'LEAVE_QUESTIONS': 'Vragen verlaten',
      'FINISH_QUESTIONS': 'Vragen voltooien',
    },
    'TEXTAREA_PLACEHOLDER': 'Typ hier een reactie',
    'SELECT': 'Selecteer optie',
    'HOLD_MODAL': {
      'TITLE': 'Wacht even',
      'DESCRIPTION': 'Om deze activiteit te voltooien moet u alle vereiste vragen invullen.',
      'BUTTON': 'DOORGAAN',
      'LEAVE_QUESTIONS_AND_RETURN_LATER': 'Verlaat Vragen en kom later terug',
    },
    'INTRODUCTION_MODAL': {
      'TITLE': 'Vragen over de participant',
      'BUTTON': 'START',
    },
    'PROJECT_HOME': 'Startpagina project',
    'RETURN': 'Terugkeren naar',
    'THANK_YOU': {
      'TITLE': 'Bedankt',
      'BUTTON': 'TERUG NAAR STARTPAGINA PROJECT',
      'BUTTON_LINK': 'VOLGENDE',
    },
    'OOPS': {
      'TITLE': 'Oeps!',
      'MESSAGE': 'Er zijn geen vragen over de participant verbonden aan dit project',
    },
    'OTHER': {
      'DEFAULT': 'Anders',
      'PLACEHOLDER': 'Typ hier uw antwoord',
    },
    'CHARACTERS_LEFT': 'tekens over',
    'ERRORS': {
      'NUMERIC': 'Het antwoord op de vraag moet tussen de minimum- en maximumwaarden liggen en mag het aangegeven aantal decimalen niet overschrijden',
    },
    'REQUIRED_FIELD': '* geeft verplicht veld aan',
  },
  // ====== RATING ===========================
  // ==========================================
  'RATING': {
    'RATING': 'BEOORDELEN',
    'SHOW_INTRO': 'Toon introductie',
    'LEAVE_QUESTION': 'Beoordelen verlaten',
    'FINISH_QUESTION': 'Beoordelen voltooien',
    'FOCUS_PROMPT': 'FOCUSVRAAG',
    'FINISH': 'Voltooi',
    'OF': 'van',
    'STATEMENTS': 'uitspraken',
    'RATED': 'beoordeeld',
    'HIDE_PROMPT': 'Verberg focusvraag',
    'IMPORTANCE': 'BELANGRIJKHEID',
    'CHOOSE_RATING': 'Kies uw beoordeling',
    'SELECT_RATING': 'KIES BEOORDELING',
    'DECIMALS_ALLOWED': 'Maximaal 2 decimalen toegestaan.',
    'MIN': 'Minimum',
    'MAX': 'Maximum',
    'MODAL': {
      'INTRODUCTION': {
        'BUTTON': 'START',
      },
      'FINISH': {
        'TITLE': 'Activiteit voltooien',
        'DESCRIPTION': 'De activiteitsstatus is al voltooid',
        'ACTIONS': {
          'CONTINUE': 'DOORGAAN',
          'LINK': 'Sorteren verlaten en later terugkomen',
        }
      }
    },
    'PROJECT_HOME': 'Startpagina project',
    'RETURN': 'Terugkeren naar',
    'THANK_YOU': {
      'TITLE': 'Bedankt',
      'BUTTON': 'TERUG NAAR STARTPAGINA PROJECT',
      'BUTTON_LINK': 'VOLGENDE',
    },
    'STATEMENTS_LIST': {
      'PAGE': 'Pagina',
      'OF': 'van',
      'STATEMENTS': 'Uitspraken',
      'TO': 'tot',
      'ON': 'Op',
      'ON_PAGE': 'Op deze pagina:',
      'ALL': 'Alle',
      'UNRATED': 'Onbeoordeeld',
      'RATED': 'Beoordeeld',
      'BACK': 'TERUG',
      'NEXT': 'VOLGENDE',
    },
    'VALIDATION_ERROR': 'De beoordeling moet tussen de minimum en maximum waarden liggen',
    'UNRATE': 'Herstellen',
  },
  // ========== SORTING ==========
  // =============================
  'SORTING': {
    'TITLE': 'Sorteren',
    'CARDS': {
      'TITLE': 'Kaarten',
      'MORE': 'meer',
      'LESS': 'minder',
      'ALL': 'Alle',
      'UNSORTED': 'Ongesorteerd',
      'SORTED': 'Gesorteerd',
      'PILES': 'Stapels',
      'SORT_IN': 'sorteren in',
      'IN_PILE': 'op een stapel',
      'UNIQUE': 'kaart',
      'MULTIPLE': 'kaart',
    },
    'INTRODUCTION': 'Versleep kaarten en laat ze los om stapels te maken',
    'OF': 'van',
    'STATEMENTS': 'uitspraken',
    'SORTED': 'gesorteerd',
    'AUTO_SAVE': 'Alle wijzigingen zijn opgeslagen',
    'FINISH': 'VOLTOOI',
    'EXPAND_ALL': 'Alles uitklappen',
    'COLLAPSE_ALL': 'Alles inklappen',
    'DROPDOWN': {
      'SHOW_INTRODUCTION': 'Toon introductie',
      'SHOW_TOUR_AGAIN': 'Tour opnieuw tonen',
      'LEAVE_SORTING': 'Sorteren verlaten',
      'FINISH_SORTING': 'Sorteren voltooien',
    },
    'MODAL': {
      'LANDSCAPE': {
        'MESSAGE': 'Plaats uw tablet scherm in liggende modus voor de beste lay-out',
      },
      'INTRODUCTION': {
        'BUTTON': 'START',
      },
      'DELETE_PILE': {
        'TITLE': 'Stapel verwijderen',
        'DESCRIPTION': 'Weet u zeker dat u de geselecteerde stapel wilt verwijderen?',
        'BUTTONS': {
          'CANCEL': 'ANNULEER',
          'YES': 'JA',
        }
      },
      'FINISH': {
        'TITLE': 'Sorry',
        'DESCRIPTION': 'U moet minimaal %0 kaarten gesorteerd hebben om de activiteit te kunnen voltooien.',
        'ACTIONS': {
          'CONTINUE': 'DOORGAAN',
          'LINK': 'Verlaat Sorteren en kom later terug',
        }
      },
      'SORT_IN': {
        'NEW_PILE': 'NIEUWE STAPEL',
        'PLACEHOLDER': 'Typ een naam',
        'NO_PILES': 'Nog geen stapels gemaakt',
        'SORT': 'SORTEREN',
        'SEND': 'VERSTUREN',
        'CARD': 'KAART %0',
        'INTO': 'NAAR...',
        'TO_PILE': 'NAAR STAPEL',
        'CREATE_NEW_PILE': '+ Nieuwe stapel maken',
        'SAVE_NEW_PILE': 'Opslaan',
        'CANCEL': '< Terug naar uitspraken',
        'SAVE': 'OPSLAAN',
        'SUCCESS': 'Kaart succesvol gesorteerd',
        'NAMING': 'Een naam geven aan stapels is belangrijk!',
        'ERROR_HELPER_PILE_NAME': 'U moet deze stapel een naam geven',
      },
      'PILE': {
        'TITLE': 'STAPEL',
        'VIEW': 'Kaarten in stapel bekijken',
        'EDIT': 'Naam van stapel bewerken',
        'DELETE': 'Stapel verwijderen',
        'CANCEL': '< Terug naar stapels',
        'SAVE': 'OPSLAAN',
        'CREATE': 'Stapel maken',
      }
    },
    'FOCUS_PROMPT': {
      'TITLE': 'FOCUSVRAAG:',
      'SUB_TITLE': 'Focusvraag hier...',
      'HIDE_PROMPT': 'Verberg focusvraag',
    },
    'DROP': {
      'CREATE': 'Laat los om aan te maken',
      'NEW': 'nieuwe stapel',
    },
    'DELETE_PILE': 'stapel verwijderen',
    'DROP_TO_CREATE': 'Laat vallen om',
    'DROP_TO_CREATE_B': 'aan te maken',
    'NEW_PILE': 'een nieuwe stapel',
    'PILE_PLACEHOLDER': 'Typ stapelnaam',
    'PROJECT_HOME': 'Startpagina project',
    'RETURN': 'Terugkeren naar',
    'THANK_YOU': {
      'TITLE': 'Bedankt',
      'BUTTON': 'TERUG NAAR STARTPAGINA PROJECT',
      'BUTTON_LINK': 'VOLGENDE',
    },
    'REVIEW': {
      'TITLE': 'Bijna klaar!',
      'UNNAMED': 'Naamloze stapels',
      'ALL_NAMED': 'Alle stapels hebben een naam!',
      'ALL_NAMED_DESCRIPTION': 'Selecteer Gereed om de activiteit te voltooien',
      'REVIEW': 'na te kijken',
      'DONE': 'Gereed',
      'FINISH': 'Voltooi zonder een naam te geven',
      'BACK': 'Terug naar sorteren',
      'ACTIONS': {
        'OK': 'OK',
        'TRY_USING': 'Gebruik',
        'OR': 'of',
        'SWITCH': 'om van stapel te wisselen',
      }
    },
    'PILES': {
      'NO_SORTED': 'Er zijn nog geen uitspraken in stapels gesorteerd',
    }
  },
  'HELP_SUPPORT': {
    'TITLE': 'Hulp & Ondersteuning',
    'SUBTITLE': 'Waarmee heeft u hulp nodig?',
    'CONTACT': {
      'TECHNICAL': 'Technische ondersteuning:',
      'SEND_MESSAGE': 'Stuur uw bericht',
      'GET_BACK': 'We nemen zo snel mogelijk contact met u op!',
      'PROJECT': 'PROJECT',
      'EMAIL_PHONE': 'CONTACT E-MAIL OF TELEFOONNUMMER',
      'OPTIONAL': 'Optioneel',
      'TOPIC': 'ONDERWERP',
      'ADDITIONAL_INFO': 'Extra informatie',
      'LET_US': 'Laat ons weten met welke activiteit u problemen heeft. Geef alle mogelijke informatie',
      'SUCCESS': 'Uw bericht is succesvol verzonden',
      'CONTACT_ERROR': 'Controleer het e-mailadres of telefoonnummer',
    },
    'MODAL': {
      'TITLE': 'Bericht kan niet verzonden worden',
      'TEXT': 'Er is voor dit project heeft geen contactpersoon bij ons bekend.',
      'CONTACT': 'U kunt contact opnemen met de technische ondersteuning of een e-mail sturen naar support@conceptsystems.com.',
      'OK': 'OK',
    },
    'MOST_FREQUENT': 'Veelgestelde vragen',
    'PQ': 'Vragen over de participant',
    'BS': 'Brainstormen',
    'TST': 'Tafelblad sorteren',
    'DST': 'Sorteren met keuzelijst',
    'RT': 'Beoordelingsvragen',
    'CONTACT_US': 'Neem contact op met ons',
    'FOR': 'voor',
    'PLACEHOLDER': 'The Future Foundation',
  },
  'FIRST_LOGIN': {
    'LINKS': {
      'PRIVACY': 'Privacy',
      'TERMS': 'Voorwaarde',
    }
  },
  'FORMS': {
    'PASSWORD_REQUIREMENTS': {
      'TITLE': 'Een veilig wachtwoord moet ten minste het volgende bevatten:',
    }
  },
  'LOCK': {
    'TITLE': 'Voltooi eerst alle vereiste vragen',
    'MESSAGE': 'U moet alle vereiste vragen invullen om de activiteit te kunnen  voltooien. U kunt ook de pagina verlaten en later terugkomen',
  },
  'BUBBLE': {
    'SKIP_INTRO': 'Sla intro over',
    'BACK': 'Terug',
    'NEXT': 'Volgende',
    'DONE': 'Gereed',
  }
};

export const LANG_NL_TRANS = Object.assign(LANG_NL, COUNTRIES_NL);



// WEBPACK FOOTER //
// ./src/app/translation/i18n/lang-nl.ts